import { useContext } from "react";
import { LayoutCellContext } from "./LayoutCellContext";
import { AllLayoutCellMapContext } from "./LayoutCellMapContext";
/**
 * Return current cell
 *
 * ⚠️ Won't work in the layout editor
 * @param options
 * @returns
 */
export function useCurrentLayoutCell(options) {
    const currentCell = useContext(LayoutCellContext);
    const map = useContext(AllLayoutCellMapContext);
    if (options.visibleLayoutOnly) {
        return currentCell;
    }
    // return cell with all sub nodes
    return map.get(currentCell.id);
}
//# sourceMappingURL=useCurrentLayoutCell.js.map